import React from 'react';

const CONTENT = {
  ro: {
    title: 'Politica de Confidențialitate (GDPR)',
    updated: 'Ultima actualizare: 20 februarie 2026',
    intro:
      'La ChessMindset.academy protejăm datele tale personale și le folosim doar pentru funcționarea platformei, progres educațional și îmbunătățirea experienței.',
    sections: [
      {
        title: '1. Operator de date',
        body: 'Operator: ChessMindset.academy. Pentru orice solicitare despre date personale ne poți scrie la contact@chessmindset.academy.'
      },
      {
        title: '2. Ce date colectăm',
        body: 'Date de cont (email, parolă criptată), profil (alias), progres lecții/puzzle-uri, puncte și nivel, date tehnice minime (IP, tip dispozitiv, jurnale tehnice).'
      },
      {
        title: '3. Scopuri și temei legal',
        body: 'Folosim datele pentru autentificare, livrarea conținutului, salvarea progresului și securitate. Temeiuri: executarea contractului (serviciul), obligații legale, interes legitim și consimțământ (acolo unde este necesar).'
      },
      {
        title: '4. Cookie-uri și tehnologii similare',
        body: 'Folosim cookie-uri strict necesare pentru sesiune și funcționare. Cookie-urile opționale (analytics/marketing) vor fi folosite doar pe bază de consimțământ explicit.'
      },
      {
        title: '5. Stocare și retenție',
        body: 'Păstrăm datele cât timp contul este activ sau cât este necesar pentru scopurile declarate și obligațiile legale. La solicitare, ștergem sau anonimizăm datele unde este aplicabil.'
      },
      {
        title: '6. Cui transmitem date',
        body: 'Folosim furnizori tehnici pentru hosting, bază de date, autentificare, media și infrastructură. Datele sunt partajate doar în măsura necesară funcționării serviciului.'
      },
      {
        title: '7. Drepturile tale GDPR',
        body: 'Ai dreptul de acces, rectificare, ștergere, restricționare, opoziție, portabilitate și retragerea consimțământului. Poți depune și plângere la autoritatea competentă.'
      },
      {
        title: '8. Securitate',
        body: 'Aplicăm măsuri tehnice și organizatorice rezonabile pentru protecția datelor, inclusiv control de acces, politici de securitate și monitorizare.'
      },
      {
        title: '9. Contact',
        body: 'Pentru cereri GDPR, întrebări sau ștergere cont: contact@chessmindset.academy.'
      }
    ]
  },
  en: {
    title: 'Privacy Policy (GDPR)',
    updated: 'Last updated: February 20, 2026',
    intro:
      'At ChessMindset.academy we protect your personal data and use it only to operate the platform, track learning progress, and improve your experience.',
    sections: [
      {
        title: '1. Data Controller',
        body: 'Controller: ChessMindset.academy. For any personal data request, contact us at contact@chessmindset.academy.'
      },
      {
        title: '2. What data we collect',
        body: 'Account data (email, hashed password), profile data (alias), lesson/puzzle progress, points and level, and minimal technical data (IP, device type, technical logs).'
      },
      {
        title: '3. Purpose and legal basis',
        body: 'We process data for authentication, content delivery, progress saving, and security. Legal bases: contract performance, legal obligations, legitimate interest, and consent where required.'
      },
      {
        title: '4. Cookies and similar technologies',
        body: 'We use strictly necessary cookies for session and core functionality. Optional cookies (analytics/marketing) are used only after explicit consent.'
      },
      {
        title: '5. Storage and retention',
        body: 'We keep data while the account is active or as needed for stated purposes and legal obligations. On request, we delete or anonymize data where applicable.'
      },
      {
        title: '6. Who we share data with',
        body: 'We use technical providers for hosting, database, authentication, media, and infrastructure. Data is shared only to the extent necessary to provide the service.'
      },
      {
        title: '7. Your GDPR rights',
        body: 'You have the right to access, rectify, erase, restrict, object, data portability, and withdraw consent. You may also lodge a complaint with the competent authority.'
      },
      {
        title: '8. Security',
        body: 'We apply reasonable technical and organizational safeguards, including access control, security policies, and monitoring.'
      },
      {
        title: '9. Contact',
        body: 'For GDPR requests, questions, or account deletion: contact@chessmindset.academy.'
      }
    ]
  }
};

function PrivacyPolicy({ language = 'ro', onBack }) {
  const c = CONTENT[language] || CONTENT.ro;

  return (
    <section className="privacy-page">
      <div className="privacy-card">
        <button type="button" className="privacy-back-btn" onClick={onBack}>
          {language === 'ro' ? '← Înapoi' : '← Back'}
        </button>
        <h1>{c.title}</h1>
        <p className="privacy-meta">{c.updated}</p>
        <p className="privacy-intro">{c.intro}</p>

        {c.sections.map((section) => (
          <article key={section.title} className="privacy-section">
            <h2>{section.title}</h2>
            <p>{section.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default PrivacyPolicy;
